import { Link } from "react-router-dom";
import { MonoButton } from "../kits";
import { useState, useRef } from "react";

import RoughBorder from "../kits/LayoutKit/RoughBorder";

export default function ZenCard({ zen }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const cardRef = useRef();

  return (
    <div ref={cardRef} className="relative">
      <Link
        to={`/zen/${zen.slug}`}
        className="shadow-lg flex flex-col justify-between rounded-2xl p-4 hover:shadow-md transition-all  
        bg-gradient-to-br from-gray-50 via-orange-50/25 to-gray-50  "
      >
        {/* ... Card-Inhalt ... */}
        <div className="flex flex-col justify-start gap-1 flex-grow min-h-[120px]">
          <div className="text-sm font-mono text-left bg-gray-950 rounded-sm sm:rounded-md text-white font-semibold tracking-tight line-clamp-2 h-[30px]">
            <p className="mt-1 px-2">{zen.title}</p>
          </div>
          <p className="text-xs font-mono text-gray-600 line-clamp-2 mt-3 px-3 h-[40px]">
            {zen.subtitle}
          </p>
        </div>
        <div className="relative w-full h-40 overflow-hidden rounded-lg mb-4">
          <img
            src={zen.image}
            alt={zen.title || "Blogbild"}
            loading="lazy"
            onLoad={() => setIsLoaded(true)}
            className={`object-cover w-full h-full transition-all duration-500
               bg-gray-50 
               pt-2 pb-2 pl-2 pr-2 rounded-md border border-gray-800 shadow-lg ${
              isLoaded ? "backdrop-blur-sm scale-100" : "blur-md scale-105"
            }`}
          />
        </div>
        <div className="mt-4">
          <MonoButton className="w-full text-xs">Mehr Zen hier</MonoButton>
        </div>
      </Link>
      <div>
      {/* RoughBorder GANZ außen! */}
      <RoughBorder
        parentRef={cardRef}
        radius={10}
        padding={2}
        color="#AC8E66" 
        strokeWidth={0.3}
        roughness={1}
        bowing={2}

        
      />
      
      </div>
    </div>
  );
}

